import React from 'react'
import { defineMessages } from 'react-intl'

import FAQItem from 'components/FaqItem'
import PageSubTitle from 'components/Page/Page.SubTitle.js'
import { View } from 'components/View.js'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'

const faqMessages = defineMessages({
  sectionTitle: {
    id: 'CheckExerciseFormFAQItems.sectionTitle',
    defaultMessage: 'Form Check & Free Trial'
  },

  howItWorksQ: {
    id: 'CheckExerciseFormFAQItems.howItWorksQ',
    defaultMessage: 'How does AI form checking work?'
  },
  howItWorksA: {
    id: 'CheckExerciseFormFAQItems.howItWorksA',
    defaultMessage:
      'Record a video of your exercise using your device camera. Our AI analyzes your movement and provides instant feedback on form, technique, and areas for improvement.'
  },

  accuracyQ: {
    id: 'CheckExerciseFormFAQItems.accuracyQ',
    defaultMessage: 'How accurate is the AI feedback?'
  },
  accuracyA: {
    id: 'CheckExerciseFormFAQItems.accuracyA',
    defaultMessage:
      'Our AI is trained on thousands of exercise demonstrations and provides reliable form analysis. Best results come from recording at the recommended angle with good lighting.'
  },

  exercisesQ: {
    id: 'CheckExerciseFormFAQItems.exercisesQ',
    defaultMessage: 'Which exercises can I check?'
  },
  exercisesA: {
    id: 'CheckExerciseFormFAQItems.exercisesA',
    defaultMessage:
      'The AI can analyze all exercises in our [exercise library](https://www.gymaholic.co/exercises) that have videos, which includes 1800+ exercises covering squats, deadlifts, bench press, overhead press, rows, and many more.'
  },

  platformsQ: {
    id: 'CheckExerciseFormFAQItems.platformsQ',
    defaultMessage: 'Does it work on iOS and Android?'
  },
  platformsA: {
    id: 'CheckExerciseFormFAQItems.platformsA',
    defaultMessage:
      'Yes. Gymaholic is available on both the App Store and Google Play.'
  },

  trialQ: {
    id: 'CheckExerciseFormFAQItems.trialQ',
    defaultMessage: 'Is there a free trial? Will I be charged today?'
  },
  trialA: {
    id: 'CheckExerciseFormFAQItems.trialA',
    defaultMessage:
      'You can start a 7-day free trial with $0 due today. Cancel anytime during the trial to avoid charges.'
  },

  caloriesQ: {
    id: 'CheckExerciseFormFAQItems.caloriesQ',
    defaultMessage: 'I came for form checking. Why do I see calorie tracking in the app?'
  },
  caloriesA: {
    id: 'CheckExerciseFormFAQItems.caloriesA',
    defaultMessage:
      'Form checking is the star of Gymaholic, and calorie tracking is included to help you reach your fitness goals. Use as much or as little of the features as you like.'
  }
})

const FAQ_ITEMS = [
  {
    title: faqMessages.sectionTitle,
    items: [
      {
        question: faqMessages.howItWorksQ,
        answer: faqMessages.howItWorksA
      },
      {
        question: faqMessages.accuracyQ,
        answer: faqMessages.accuracyA
      },
      {
        question: faqMessages.exercisesQ,
        answer: faqMessages.exercisesA
      },
      {
        question: faqMessages.platformsQ,
        answer: faqMessages.platformsA
      },
      {
        question: faqMessages.trialQ,
        answer: faqMessages.trialA
      },
      {
        question: faqMessages.caloriesQ,
        answer: faqMessages.caloriesA
      }
    ]
  }
]

export function CheckExerciseFormFAQItems () {
  const intl = useIntl()

  return (
    <View className='app-faq-items'>
      {
        FAQ_ITEMS.map((section) => {
          const titleStr = formatMessageIntlUtil(intl, section.title)

          return (
            <View key={titleStr}>
              <PageSubTitle>{titleStr}</PageSubTitle>

              {
                section.items.map((item) => {
                  const questionStr = formatMessageIntlUtil(intl, item.question)
                  const answerStr = formatMessageIntlUtil(intl, item.answer)

                  return (
                    <FAQItem
                      key={questionStr}
                      question={questionStr}
                      answer={
                        <View style={{
                          textAlign: 'left'
                        }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: markdownToHtmlStringUtil(answerStr)
                            }}
                          />
                        </View>
                      }
                    />
                  )
                })
              }
            </View>
          )
        })
      }
    </View>
  )
}
